module.exports = __webpack_public_path__ + "static/media/catalouge-30.99d3111f.jpg";